import { forwardRef } from "react";

import Icon from "@/components/Icon";
import ReorderIconRaw from "./ReorderIconRaw.svg.jsx";

const ReorderIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={ReorderIconRaw} {...props} />;
});

ReorderIcon.displayName = "ReorderIcon";
export default ReorderIcon;
